import {
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import { Redirect } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import MailOutline from "@material-ui/icons/MailOutline";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import PropTypes from "prop-types";
import CustomInput from "components/CustomInput/CustomInput";
import { useParams } from "react-router-dom";
import { bookingApi } from "functions/apis";

const useStyles = makeStyles(styles);

const DeleteAppsNotification = props => {
  const classes = useStyles();

  const [redirect, setRedirect] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [section, setSection] = useState([]);
  const [input, setInput] = useState({
    title: "",
    description: "",
    url: "",
    pushNotificationSection: "",
    name: ""
  });
  const { id } = useParams();

  const DeleteAppsNotificationSignal = useRef(new AbortController());

  useEffect(() => {
    return () => {
      DeleteAppsNotificationSignal.current.abort();
    };
  }, []);

  useEffect(() => {
    if (id) {
      bookingApi
        .get("appsnotifications/" + id, {
          signal: DeleteAppsNotificationSignal.current.signal
        })
        .then(resp => {
          setInput({
            ...input,
            name: resp.name ?? "",
            title: resp.title ?? "",
            description: resp.description ?? "",
            pushNotificationSection: resp.notificationSection
              ? resp.notificationSection.id
              : "",
            url: resp.url ?? ""
          });
        });

      bookingApi
        .get("appsNotificationSections", {
          signal: DeleteAppsNotificationSignal.current.signal,
          params: {
            filter: {},
            pagination: {}
          }
        })
        .then(resp => {
          setSection(resp.records);
        });
    }
  }, [id]);

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);
  };

  const handleDelete = e => {
    e.preventDefault();
    bookingApi
      .delete("appsNotifications/" + id, {
        signal: DeleteAppsNotificationSignal.current.signal
      })
      .then(() => {
        setRedirect(true);
      });
  };

  return redirect ? (
    <Redirect to={"/admin/AppsNotification/List"} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Delete Apps Notification</h4>
          </CardHeader>
          <CardBody>
            <i>*Are you sure to delete this apps notification data?</i>
            <form onSubmit={handleDelete}>
              <Button onClick={() => props.history.goBack()} value="Cancel">
                CANCEL
              </Button>
              <Button
                disabled={disabled}
                color="rose"
                type="submit"
                value="Submit"
              >
                DELETE
              </Button>
            </form>

            <form onSubmit={handleSubmit}>
              <CustomInput
                labelText="Name"
                formControlProps={{
                  fullWidth: true
                }}
                disabled
                inputProps={{
                  value: input.name,
                  disabled: true
                }}
              />
              <CustomInput
                labelText="Title"
                formControlProps={{
                  fullWidth: true
                }}
                disabled
                inputProps={{
                  value: input.title,
                  disabled: true
                }}
              />
              <CustomInput
                labelText="Description"
                formControlProps={{
                  fullWidth: true
                }}
                disabled
                inputProps={{
                  value: input.description,
                  disabled: true
                }}
              />
              <CustomInput
                labelText="Url"
                formControlProps={{
                  fullWidth: true
                }}
                disabled
                inputProps={{
                  value: input.url ?? "",
                  disabled: true
                }}
              />
              <FormControl
                disabled
                fullWidth
                className={classes.selectFormControl}
              >
                <InputLabel
                  htmlFor="selCategory"
                  className={classes.selectLabel}
                >
                  Section
                </InputLabel>
                <Select
                  MenuProps={{
                    classes: classes.selectMenu
                  }}
                  classes={{
                    select: classes.select
                  }}
                  disabled={true}
                  value={input.pushNotificationSection ?? ""}
                >
                  {section.map(val => (
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      key={val.id}
                      value={val.id}
                    >
                      <b>{val.name}</b>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default DeleteAppsNotification;

DeleteAppsNotification.propTypes = {
  history: PropTypes.object
};
